var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-badge',{staticClass:"image-preview-icon",attrs:{"content":_vm.cellData.length ? _vm.cellData.length : '0',"color":"#3B82F6","overlap":"","offset-x":"10","offset-y":"10"}},[_c('image-field',{attrs:{"src":_vm.config.src || '/img/icons/table-image-icon.svg',"width":"20","height":"20","contain":""},on:{"onClick":_vm.onClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }